import type { FC } from 'react';

interface HelpImageProps {
  url: string;
  alt?: string;
  width?: string | number;
}

export const HelpImage: FC<HelpImageProps> = ({ url, alt, width }) => {
  return (
    <figure>
      <img
        src={url}
        alt={alt}
        style={{
          width: width,
          maxHeight: '70vh',
        }}
      />
    </figure>
  );
};
